import {destroyAccordions, setAccordionDisplay, setupAccordions} from "../helpers/accordions";

/**
 * For custom select
 */
export default class Select {
	constructor() {
		this.initEvents();
        this.isInMobileView = false;
	}

    initEvents() {
        for(let select of document.querySelectorAll('.custom-select-wrapper')) {
            select.addEventListener('click', () => {
                select.querySelector('.custom-select').classList.toggle('open');
            });

            for(const option of select.querySelectorAll('.custom-option')) {
                option.addEventListener('click', () => {
                    if (option.classList.contains('default')) {
                        select.querySelector('.custom-option.selected')?.classList.remove('selected');
                        const triggerSpan = select.querySelector('.custom-select__trigger span');
                        if (triggerSpan) {
                            triggerSpan.textContent = select.querySelector('.custom-select__placeholder')?.getAttribute('data-default');
                        }
                        select.querySelector('.custom-select__trigger')?.classList.remove('checked');
                    } else if (!option.classList.contains('selected')) {
                        select.querySelector('.custom-option.selected')?.classList.remove('selected');
                        option.classList.add('selected');
                        if(document.getElementsByClassName('soon-events-section')[0]) {
                            option.closest('.custom-select').querySelector('.custom-select__trigger span').innerHTML = `${option.textContent}`;
                        } else {
                            option.closest('.custom-select').querySelector('.custom-select__trigger span').innerHTML = option.innerHTML;
                        }
                    }
                    const accordion = select.querySelector('.accordion-select')
                    if (accordion) {
                        setAccordionDisplay(accordion, false)
                    }
                })
            }

            let options_container = select.querySelector('.custom-options');
            if(options_container.getBoundingClientRect().bottom > document.body.getBoundingClientRect().bottom) {
                options_container.classList.add('custom-options-placement-top');
            }

            window.addEventListener('click', (e) => {
                if (!select.contains(e.target)) {
                    select.querySelector('.custom-select').classList.remove('open');
                }
            });
        }

        window.addEventListener('resize', () => {
            //When we go from the mobile to the laptop layout, we need to reset the accordions displays, else the options' layout won't appear
            const newIsInMobileView = window.innerWidth <= 800;
            if (!newIsInMobileView && this.isInMobileView) {
                destroyAccordions();
            } else if (newIsInMobileView && !this.isInMobileView) {
                setupAccordions();
            }
            this.isInMobileView = newIsInMobileView
        });
	}
}
